<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            type: "treemap",
            data: [
              {
                name: "Node 1",
                value: 10,
                children: [
                  { name: "Sub-node 1", value: 4 },
                  { name: "Sub-node 2", value: 6 }
                ]
              },
              {
                name: "Node 2",
                value: 20
              }
            ]
          }
        ]
      }
    };
  }
};
</script>
